import { store } from "../../store";
import {
  urlAddTenant,
  getFetchConfig,
  handleRawResponse,
  handleJsonResponse,
  NETWORK_WARNINGS_ACTIVE,
  NETWORK_WARNINGS_INACTIVE,
} from ".";
import { applicationSubmitPost } from "../../mocks/applicationSubmitPost";
import { applicationPostMock } from "../../mocks/applicationPost";
import { applicationPutMock } from "../../mocks/applicationPut";
import { getUserId } from "../../userId";
import { API_SET_APPLICATION_DATA } from "..";
import { delayedPromise } from "../../delayedPromise";

/**
 * POST /{tenant}/rest/v1/accountapplications
 */
export const applicationCreate = (
  primaryPhone,
  shouldProceedOnMobile,
  resendSmsCode
) => (dispatch) => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  let promise = null;
  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = delayedPromise(applicationPostMock);
  } else {
    promise = postApplication({
      user: { primaryPhone: `+${primaryPhone}`, userId: getUserId() },
      shouldProceedOnMobile,
      resendSmsCode,
    });
  }
  return promise.then((payload) => {
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    dispatch({ type: API_SET_APPLICATION_DATA, payload });
    return payload;
  });
};

/**
 * POST /{tenant}/rest/v1/accountapplications
 */
export const applicationContinue = (primaryPhone, smsCode) => (dispatch) => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  let promise = null;
  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = delayedPromise(applicationPutMock);
  } else {
    promise = postApplication({
      user: { primaryPhone, smsCode },
    });
  }

  return promise.then((payload) => {
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    dispatch({ type: API_SET_APPLICATION_DATA, payload });
    return payload;
  });
};

/**
 * PUT /{tenant}/rest/v1/accountapplications/{applicationId}?smsCode={smsCode}
 */
export const applicationSendCode = (smsCode) => (dispatch) => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  let promise = null;
  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = delayedPromise(applicationPutMock);
  } else {
    const controller = new AbortController();
    const signal = controller.signal;
    const { application } = store.getState();
    promise = fetch(
      urlAddTenant(
        `/rest/v1/accountapplications/${application.id}?smsCode=${smsCode}`
      ),
      {
        ...getFetchConfig(),
        method: "PUT",
        signal,
        credentials: "same-origin", // to support older browser versions where fetch credentials are defaulting to 'omit'
        body: JSON.stringify(application),
      }
    ).then((rawResponse) => {
      return handleRawResponse(rawResponse).then((res) =>
        handleJsonResponse(res, rawResponse.ok)
      );
    });
    setTimeout(() => {
      controller.abort();
    }, process.env.REACT_APP_CLIENT_TIMEOUT || 30000);
  }

  return promise.then((payload) => {
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    dispatch({ type: API_SET_APPLICATION_DATA, payload });
  });
};

function postApplication(request) {
  const controller = new AbortController();
  const signal = controller.signal;
  setTimeout(() => {
    controller.abort();
  }, process.env.REACT_APP_CLIENT_TIMEOUT || 30000);
  return fetch(urlAddTenant(`/rest/v1/accountapplications`), {
    ...getFetchConfig(),
    method: "POST",
    credentials: "same-origin",
    signal, // to support older browser versions where fetch credentials are defaulting to 'omit'
    body: JSON.stringify(request),
  }).then((rawResponse) => {
    return handleRawResponse(rawResponse).then((res) =>
      handleJsonResponse(res, rawResponse.ok)
    );
  });
}

/**
 * PUT /{tenant}/rest/v1/accountapplications/{applicationId}/submit?evaluationPolicyName={evaluationPolicyName}
 */
export const applicationSubmit = () => (dispatch) => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  let promise;
  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = Promise.resolve(applicationSubmitPost);
  } else {
    const { application, configuration } = store.getState();
    const controller = new AbortController();
    const signal = controller.signal;
    setTimeout(() => {
      controller.abort();
    }, process.env.REACT_APP_CLIENT_TIMEOUT || 30000);
    promise = fetch(
      urlAddTenant(
        `/rest/v1/accountapplications/${application.id}/submit?evaluationPolicyName=${configuration.evaluationPolicyName}`
      ),
      {
        ...getFetchConfig(),
        method: "POST",
        signal,
        credentials: "same-origin", // to support older browser versions where fetch credentials are defaulting to 'omit'
        body: JSON.stringify(application),
      }
    ).then(handleRawResponse);
  }
  return promise.then((response) => {
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    return response;
  });
};
